import { render } from "./ProjectsPanelProject.vue?vue&type=template&id=79fef350&scoped=true&ts=true"
import script from "./ProjectsPanelProject.vue?vue&type=script&lang=ts"
export * from "./ProjectsPanelProject.vue?vue&type=script&lang=ts"

import "./ProjectsPanelProject.vue?vue&type=style&index=0&id=79fef350&lang=scss&scoped=true"

import exportComponent from "/Users/otto/Code/projects/bubbly/doo/apps/builder-legacy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79fef350"]])

export default __exports__